const focusedClass = 'accordion--focused';

const init = () => {

	// Loop through accordion elements
	for (const el of document.querySelectorAll('[data-accordion]')) {

		el.addEventListener('keydown', (e) => {
			handleAccordionKeyDown(e, el);
		});

		// Loop through all buttons inside title elements in accordion
		for (const trigger of el.querySelectorAll('[data-accordion-title] button')) {

			trigger.addEventListener('click', handleTriggerClick);
			trigger.addEventListener('focus', (e) => {
				el.classList.add(focusedClass);
			});
			trigger.addEventListener('blur', (e) => {
				el.classList.remove(focusedClass);
			});
		}
	}
}

const handleAccordionKeyDown = (e, accordion) => {

	// Get target of event
	const target = e.target;

	// Determine which key was pressed
	const key = e.which.toString();

	// Get triggers as an array
	const triggers = Array.prototype.slice.call(accordion.querySelectorAll('[data-accordion-title] button'));

	// 33 = Page Up, 34 = Page Down
	const ctrlModifier = (e.ctrlKey && key.match(/33|34/));
	
	// If event came from title trigger
	if (target.hasAttribute('aria-controls')) {

		// Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
		// 38 = Up, 40 = Down
		if (key.match(/38|40/) || ctrlModifier) {

			// Determine which trigger to focus on
			const index     = triggers.indexOf(target);
			const direction = (key.match(/34|40/)) ? 1 : -1;
			const length    = triggers.length;
			const newIndex  = (index + length + direction) % length;

			triggers[newIndex].focus();

			e.preventDefault();

		} else if (key.match(/35|36/)) {

			switch (key) {
				// Go to first accordion section trigger
				case '36':
					triggers[0].focus();
					break;
				// Go to last accordion section trigger
				case '35':
					triggers[triggers.length - 1].focus();
					break;
			}

			e.preventDefault();
		}
	}
}

const handleTriggerClick = (e) => {

	// Get trigger element that was clicked
	const trigger = e.target;

	// Get the section id that it controls
	const sectionId = trigger.getAttribute('aria-controls');

	// Find relevant accordion section
	const section = document.getElementById(sectionId);

	// If found...
	if (section !== null) {

		// Check if section is currently expanded
		const isExpanded = (trigger.getAttribute('aria-expanded') == 'true');

		// Toggle aria-expanded attribute value as needed
		trigger.setAttribute('aria-expanded', (isExpanded) ? 'false' : 'true');
		
		// Toggle if relevant section is hidden or not
		section.toggleAttribute('hidden');
	}
}

export default init;